import { Box, Card, Typography, Container, Divider } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import Footer from 'src/components/Footer';

const MainContent = styled(Box)(
  ({ theme }) => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: ${theme.spacing(4)} 0;
`
);

function Terms() {
  return (
    <>
      <Helmet>
        <title>Terms of Use - Portfoliomatic</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="md">
          <Card sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom>
              Terms of Use
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Typography variant="h5" component="h2" gutterBottom>
              1. Acceptance
            </Typography>
            <Typography variant="body1" paragraph>
              By accessing or using this website, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use Portfoliomatic.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              2. Educational Use Only
            </Typography>
            <Typography variant="body1" paragraph>
              Portfoliomatic is intended for educational and informational purposes only. We do not provide financial advice or act as a registered investment advisor. All content is provided for learning and simulation purposes.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              3. User Responsibility
            </Typography>
            <Typography variant="body1" paragraph>
              You are solely responsible for any trades you make based on content or suggestions provided by Portfoliomatic. We strongly encourage you to consult with a licensed financial advisor before acting on any strategy or making investment decisions.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              4. No Warranty / Limitation of Liability
            </Typography>
            <Typography variant="body1" paragraph>
              We do not warrant the accuracy, completeness, or usefulness of any information provided. Your use of the platform is at your own risk. We are not liable for any loss or damage resulting from use of the site, including but not limited to financial losses, data loss, or interruption of service.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              5. Email Notifications
            </Typography>
            <Typography variant="body1" paragraph>
              By creating an account, you are automatically subscribed to email notifications including trade suggestions and account updates. These notifications are based on your configuration and are for educational use only. Portfoliomatic is not responsible for actions you take based on those emails.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              6. Data Privacy & Security
            </Typography>
            <Typography variant="body1" paragraph>
              We store and process your information in accordance with our Privacy Policy. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              7. Changes to the Platform
            </Typography>
            <Typography variant="body1" paragraph>
              We may modify, suspend, or discontinue features without notice. We are not liable for interruptions, errors, or changes to the platform that may affect your use or data.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              8. Intellectual Property
            </Typography>
            <Typography variant="body1" paragraph>
              All content, features, and functionality on Portfoliomatic are owned by us and are protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              9. Prohibited Uses
            </Typography>
            <Typography variant="body1" paragraph>
              You agree not to use Portfoliomatic for any unlawful purpose, to violate any applicable laws, or to interfere with the proper functioning of the platform. You may not attempt to gain unauthorized access to any part of the system.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              10. Termination
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to terminate or suspend your account at any time for violation of these terms or for any reason at our sole discretion.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              11. Governing Law
            </Typography>
            <Typography variant="body1" paragraph>
              These Terms of Use shall be governed by and construed in accordance with the laws of Canada, without regard to conflict of law principles.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              12. Voluntary Contributions
            </Typography>
            <Typography variant="body1" paragraph>
              Portfoliomatic offers users the option to make a voluntary, one-time monetary contribution ("Support Portfoliomatic") to support the platform's continued development. Contributions are entirely optional and are not required to access any feature of the platform.
            </Typography>
            <Typography variant="body1" paragraph>
              Contributions are non-refundable, except where refunds are issued at our sole discretion outside of the ordinary course of business. Contributions are not tax-deductible. Portfoliomatic is not a registered charity or non-profit organization, and no receipt for tax purposes will be issued.
            </Typography>
            <Typography variant="body1" paragraph>
              Making a contribution does not grant you any feature, perk, right, or entitlement beyond what your existing account already provides, and does not constitute a purchase of any product or service.
            </Typography>

            <Typography variant="body2" sx={{ mt: 4, fontStyle: 'italic' }}>
              Last updated: {new Date().toLocaleDateString()}
            </Typography>
          </Card>
        </Container>
      </MainContent>
      <Footer />
    </>
  );
}

export default Terms;